document.querySelectorAll("p").forEach(function (p) {
  if (p.innerHTML.trim() === "&nbsp;") {
    p.classList.add("hidden-content");
  }
});

document.querySelectorAll(".job__apply-button").forEach(function (button) {
  button.addEventListener("click", function () {
    document.querySelectorAll(".scroll-form").forEach(function (form) {
      form.style.display = "block";
    });

    const form = document.querySelector(".scroll-form");
    if (form) {
      const offsetTop = form.getBoundingClientRect().top + window.scrollY - 80;
      window.scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  });
});
